/**
 * @file NewPatientViewModel.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { Subject } from "rxjs";
import { ApiService } from "../../../../services/network/ApiService";
import { ApiError } from "../../../../services/models/ApiError";
import { UserRequest } from "../../../../services/models/UserRequest";
import ViewModel from "../../../base/ViewModel";
import { CreatePatientResponse } from "../../../../services/models/CreatePatientResponse";
import { NewAdminViewModel } from "../../admin/viewmodels/NewAdminViewModel";
const { v4: uuidv4 } = require('uuid'); // eslint-disable-line

/**
 * A class definition for NewPatientViewModel
 */
export class NewPatientViewModel extends ViewModel {

    onLoadQrCode = new Subject<UserRequest>();
    onLoadQrCodeError = new Subject<ApiError>();


    onPatientCreated = new Subject<CreatePatientResponse>();
    onPatientCreatedError = new Subject<ApiError>();

    /**
     * Generates QR code
     * @param username string
     * @param time string
     */
    async generateQr(username: string, time: string) {
        try {
            const password = uuidv4();
            const user = new UserRequest(username, password, 'Anonymous', time)
            // const apiService = new ApiService();
            // await apiService.createPatient(username)
            this.onLoadQrCode.next(user)
        } catch (e) {
            if (e instanceof ApiError) {
                this.logger.verbose(`Error generating Qr - ${e.message}`, NewAdminViewModel.name);
            }
            this.onLoadQrCodeError.next(e as ApiError)
        }
    }

    /**
     * Creates patient
     * @param clinicid string
     * @param accessToken string
     * @param patietnIdentifier string
     */
    async createPatient(clinicid: string, accessToken: string, patietnIdentifier?: string) {
        try {
            let patient = {
                clinicId: clinicid
            } as any;
            if(patietnIdentifier) {
                patient = {
                    clinicId: clinicid,
                    identifier: patietnIdentifier
                };
            }
            const apiService = new ApiService()
            const respoonse = await apiService.createPatient(patient, accessToken)
            if(respoonse instanceof ApiError){
                throw respoonse;
            }
            this.onPatientCreated.next(respoonse as CreatePatientResponse)
        } catch (e) {
            if (e instanceof ApiError) {
                this.logger.verbose(`Error creating Patient - ${e.message}`, NewAdminViewModel.name);
            }
            this.onPatientCreatedError.next(e as ApiError)
        }
    }

}